import React, { useState, useEffect } from "react";

import CounterCard from "../counterCard/CounterCard";

import styles from './OrdersCount.module.scss';

type OrdersCountProps = {
    count: string | number;
};

function OrdersCount({count}: OrdersCountProps) {

    const countValue = Number(count);
    const [displayCount, setDisplayCount] = useState(countValue - 2);

    useEffect(() => {
        const interval = setInterval(() => {
            setDisplayCount(prev => {
                if (prev < countValue) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [countValue]);

    const numbersToDisplay = String(displayCount).padStart(6, '0').split('');

    if (!count) return (
        <div className={styles.cardsEmpty}/>
    );

    return (
        <div className={styles.cards}>
            {numbersToDisplay.map((digit, index) => (
                <div className={styles.card} key={index}>
                    <CounterCard time={digit} isSmall/>
                </div>
            ))}
        </div>
    );
}

export default OrdersCount;
